import { connect } from 'react-redux';
import { appNamedRoutes } from 'routes';
import { getQueryFromState } from 'utils/query';
import AccountPlayerHeader from 'components/accountplayer/AccountPlayerHeader';

const mapStateToProps = (state) => {
  return {
    backLink: { pathname: appNamedRoutes.accountPlayers, search: getQueryFromState(state.meta.accountPlayers, 'accountPlayers')},
  }
}

const AccountPlayerHeaderContainer = connect(
  mapStateToProps,
  null
)(AccountPlayerHeader)

export default AccountPlayerHeaderContainer;
